// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "huihanstatic/css/" + chunkId + "." + {"5":"95021b41","193":"be0d5ac4","237":"279e73c1","244":"11cfc09e","358":"54970eb9","376":"8e5d628d","489":"110ef250","585":"99a8d45c","612":"bea999bc","661":"e4914d7c","675":"9fbfd623","862":"b4537e36","922":"3a5a7550","963":"17a71148","969":"4e64b99e"}[chunkId] + ".css";
};